module.exports = __webpack_public_path__ + "static/client-dukcapil-salatiga-6defb6069a4cd16c0431cbd1b0312959.png";